module.exports = "pegasus_template/assets/circleline-google.png";